import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PropertyKey } from '../propertyMetadata';
import { finishDeletingView, finishOverwritingView, finishSavingView, setActiveView } from './viewsSlice';

interface GridState {
  readonly index: number;
  readonly sort: PropertyKey;
  readonly isAscending: boolean;
}

const initialState: GridState = {
  index: 0,
  sort: 'id',
  isAscending: false,
};

const gridSlice = createSlice({
  name: 'grid',
  initialState,
  reducers: {
    sortByColumn: (state, action: PayloadAction<PropertyKey>) => {
      if (action.payload === state.sort) {
        state.isAscending = !state.isAscending;
      } else {
        state.sort = action.payload;
        state.isAscending = true;
      }
    },
    setPageIndex: (state, action: PayloadAction<number>) => {
      state.index = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(finishDeletingView, (state) => {
      state.index = 0;
      state.isAscending = false;
      state.sort = 'id';
    });
    builder.addCase(finishSavingView, (state) => {
      state.index = 0;
      state.isAscending = false;
      state.sort = 'id';
    });
    builder.addCase(finishOverwritingView, (state) => {
      state.index = 0;
      state.isAscending = false;
      state.sort = 'id';
    });
    builder.addCase(setActiveView, (state) => {
      state.index = 0;
      state.isAscending = false;
      state.sort = 'id';
    });
  },
});

export const { sortByColumn, setPageIndex } = gridSlice.actions;
export const grid = gridSlice.reducer;
